module.exports = __webpack_public_path__ + "static/media/ct-50.8114a493.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/ct-50.png
// module id = 89
// module chunks = 0